import { useTranslation } from 'react-i18next';
import useBrowserNotifications from '@/hooks/use-browser-notifications';
import useChatWidgetOpen from './use-chat-widget-open';
import type { ChatApprovalRequiredEvent } from './use-chat-ws';

// Scoped to the active chat socket on purpose, unlike the layout-mounted RunCompletionWatcher: an
// approval only notifies while this tab holds the session, and approvals replayed in `ready` history
// are skipped so a reconnect doesn't re-notify.
const useApprovalRequiredNotification = () => {
  const { t } = useTranslation('agents', { keyPrefix: 'floatingChat.notifications' });
  const { notify } = useBrowserNotifications();
  const { open } = useChatWidgetOpen();

  return (event: ChatApprovalRequiredEvent) => {
    notify(
      t($ => $.needsInputTitle),
      {
        body: t($ => $.approvalBody),
        tag: `percy-approval-${event.approvalId}`,
        onClick: open,
      },
    );
  };
};

export default useApprovalRequiredNotification;
